import React, {useState} from "react";
import {withRouter} from "react-router";
import "pages/Front/Login/Login.scss";
import clsx from "clsx";
import AdminDashboardOneColumnLayout from "../components/AdminDashboardOneColumnLayout";
import WorldMap from "./WorldMap";
import SidePanel from "./SidePanel";

const AdminDashboard = () => {
    const profile = {name: "Admin", hall: {hallOpeningHours: ["8", "24"]}};
    const [tooltipActive, setTooltipActive] = useState<boolean | null>(null);
    const [panelActive, setPanelActive] = useState<number | null>(null);
    const [isOpen, setIsOpen] = useState(false);

    const activeCountries: string[] = ["CH", "HU", "SK"];
    const halls: any[] = [
        {
            name: "Tempodrom Winterthur",
            status: "opened",
            image: "tempodrom-winterthur.svg",
            track_map: "layout_tempodrom_aussenbahn.png",
            short_address: "Winterthur, Switzerland",
            address: "Steigstrasse 5, 8406 Winterthur, Switzerland",
            description: "280m / 380m Asphalt",
            karts: 20,
            year: 2010,
            country: "CH",
            hallOpeningHours: ["8", "24"],
            kartsInUse: "6",
            kartsMaximum: "8",
            waitingTimeMinutes: "25",
            peopleInQueue: "30",
            performance: "8.5",
            top: "53.5%",
            left: "36.6%",
            transform: "169 296",
        },
        {
            name: "Kartbahn Spreitenbach",
            status: "opened",
            image: "kartbahn-spreitenbach-logo.svg",
            track_map: "layout_spreitenbach.png",
            short_address: "Spreitenbach, Switzerland",
            address: "Steigstrasse 5, 8406 Spreitenbach, Switzerland",
            description: "280m / 380m Asphalt",
            karts: 20,
            year: 2010,
            country: "CH",
            hallOpeningHours: ["8", "24"],
            kartsInUse: "6",
            kartsMaximum: "8",
            waitingTimeMinutes: "25",
            peopleInQueue: "30",
            performance: "8.5",
            top: "53.9%",
            left: "34.35%",
            transform: "159 301",
        },
        {
            name: "FlashKart Budapest",
            status: "opened",
            image: "flashkart-logo_w.png",
            short_address: "Budapest, Hungary",
            address: "Blaha Lujza 5, 1102 Budapest, Hungary",
            description: "280m / 380m Asphalt",
            karts: 20,
            year: 2010,
            country: "HU",
            hallOpeningHours: ["8", "24"],
            kartsInUse: "6",
            kartsMaximum: "8",
            waitingTimeMinutes: "25",
            peopleInQueue: "30",
            performance: "8.5",
            top: "51.2%",
            left: "55.9%",
            transform: "254 285",
        },
        {
            name: "Volt Trencin",
            status: "closed",
            image: "volt-racing-logo.svg",
            track_map: "layout_trencin.png",
            short_address: "Trencin, Slovakia",
            address: "Zlatovska 325, 91101 Trencin, Slovakia",
            description: "280m / 380m Asphalt",
            karts: 20,
            year: 2010,
            country: "SK",
            hallOpeningHours: ["8", "24"],
            kartsInUse: "6",
            kartsMaximum: "8",
            waitingTimeMinutes: "25",
            peopleInQueue: "30",
            performance: "8.5",
            top: "48.3%",
            left: "53.7%",
            transform: "244 271",
        },
        // {
        //     name: "Powrracing Academy",
        //     status: "closed",
        //     image: "powerracing.png",
        //     shortAddress: "Herlev, Denmark",
        //     address: "powerstrasse, 1234 Herlev, Denmark",
        //     description: "280m / 380m Asphalt",
        //     karts: 20,
        //     year: 2010,
        //     country: "DK",
        //     hallOpeningHours: ["8", "24"],
        //     kartsInUse: "6",
        //     kartsMaximum: "8",
        //     waitingTimeMinutes: "25",
        //     peopleInQueue: "30",
        //     performance: "8.5",
        //     top: "32%",
        //     left: "36.4%",
        // },
    ];

    const handlePanelActive = index => {
        if (panelActive === index) {
            if (tooltipActive === null) {
                setTooltipActive(index);
            } else {
                setTooltipActive(null);
            }
        } else {
            setTooltipActive(index);
        }
        setPanelActive(index);
        setIsOpen(true);
    };
    return (
        <div className={clsx("AdminDashboard flex relative z-2 justify-evenly flex w-full h-full flex-col items-stretch max-w-9xl ml-auto mr-auto")}>
            <AdminDashboardOneColumnLayout
                content={
                    <>
                        <WorldMap
                            activeCountries={activeCountries}
                            className={"h-full w-full"}
                            halls={halls}
                            tooltipActive={tooltipActive}
                            onClick={hall => {
                                handlePanelActive(hall);
                            }}
                        />
                        <SidePanel
                            active={panelActive}
                            halls={halls}
                            isOpen={isOpen}
                            setActive={setPanelActive}
                            setIsOpen={setIsOpen}
                            onClick={() => {
                                alert("sidePanel");
                            }}
                        />
                    </>
                }
            />
        </div>
    );
};

export default withRouter(AdminDashboard);
